module.exports = __webpack_public_path__ + "static/media/rebirth_sample_6.2aeba8c1.jpg";